import { render, staticRenderFns } from "./NavBarTherapist.vue?vue&type=template&id=6c24aa72&"
import script from "./NavBarTherapist.vue?vue&type=script&lang=js&"
export * from "./NavBarTherapist.vue?vue&type=script&lang=js&"
import style0 from "./NavBarTherapist.vue?vue&type=style&index=0&id=6c24aa72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports